import SessionRouter from "./SessionRouter";
import AppRouter from "./AppRouter";

const routers = { SessionRouter, AppRouter };

export default routers;
